import axios from 'axios';
import router from '../Routes';
import config from '../config';
import { firebaseApp, firestore } from '../main';
import * as firebase from 'firebase';
import { getDatabase, ref, runTransaction } from 'firebase/database';

export default {
  namespaced: true,
  state: {
    groups: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null
  },
  mutations: {
    RECEIVED_GROUPS(state, payload) {
      state.groups = payload;
      state.isReceiving = false;
    },
    RECEIVING_GROUPS(state) {
      state.isReceiving = true;
    },
    UPDATED_GROUP(state, payload) {
      let index = state.groups.findIndex(p => p.id === payload.id);
      state = Object.assign(state, {
        groups: state.groups.map((p, i) => {
          if (i === index) {
            return Object.assign({}, p, payload);
          }
          return p;
        }),
        isUpdating: false
      });
    },
    UPDATING_GROUP(state) {
      state.isUpdating = true;
    },
    DELETED_GROUP(state, payload) {
      let indexToDelete = state.groups.findIndex(p => p.id === payload.id);
      let groups = [...state.groups];
      groups.splice(indexToDelete, 1);
      state = Object.assign(state, {
        groups: [...groups],
        isDeleting: false,
        idToDelete: null
      });
    },
    DELETING_GROUP(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    }
  },
  actions: {
    async getGroupsByTenantRequest({ dispatch }, tenantId) {
      dispatch('receivingGroups');
      // debugger;
      const snapshot = await firestore
        .collection('groups')
        .where('tenantId', '==', tenantId)
        .get();
      const groups = [];
      snapshot.docs.forEach(doc => {
        groups.push(Object.assign({}, doc.data(), { id: doc.id }));
      });
      dispatch('receiveGroups', groups);
    },
    getGroupsRequest({ dispatch }) {
      dispatch('receivingGroups');
      firebaseApp
        .auth()
        .currentGroup.getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + idToken;
          axios
            .get('/console-groups')
            .then(res => {
              dispatch('receiveGroups', res.data);
            })
            .catch(function(error) {
              console.log('Error on getting groups', error);
              dispatch('receiveGroups', []);
              payload.$toasted.error('Groups could not be retrieved!');
            });
        })
        .catch(function(error) {
          dispatch('receiveGroups', []);
          payload.$toasted.error('Groups could not be retrieved!');
        });
    },
    async updateGroupRequest({ dispatch }, payload) {
      dispatch('updatingGroup');
      var group = {};
      var userIds = [];
      for (let i = 0; i < payload.group.users.length; i++) {
        userIds.push(payload.group.users[i].id);
      }
      group.name = payload.group.name;
      group.userIds = userIds;
      group.id = payload.id;
      group.tenantId = payload.group.tenantId;
      const groupRef = await firestore
        .collection('groups')
        .doc(group.id)
        .set(group, { merge: true });
      const groupSnapshot = await firestore
        .collection('groups')
        .doc(group.id)
        .get();
      dispatch('updateGroup', Object.assign({}, groupSnapshot.data(), { id: groupSnapshot.id }));
      payload.$toasted.success('Group has been updated!');
    },
    async createGroupRequest({ dispatch }, payload) {
      dispatch('updatingGroup');
      var group = {};
      var userIds = [];
      for (let i = 0; i < payload.group.users.length; i++) {
        userIds.push(payload.group.users[i].id);
      }
      group.name = payload.group.name;
      group.userIds = userIds;
      group.tenantId = payload.group.tenantId;
      // payload.delete(group.users);
      const groupRef = await firestore.collection('groups').add(group);
      const groupSnapshot = await firestore
        .collection('groups')
        .doc(groupRef.id)
        .get();
      payload.$toasted.success('Group has been created!');
      dispatch('updateGroup', Object.assign({}, groupSnapshot.data(), { id: groupRef.id }));
    },
    deleteGroupRequest({ dispatch }, payload) {
      dispatch('deletingGroup', payload);
      firebaseApp
        .auth()
        .currentGroup.getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + idToken;
          axios
            .delete('/console-groups/' + payload.id)
            .then(() => {
              dispatch('deleteGroup', { id: payload.id });
              if (router.history.current.pathname !== '/app/admin/group-management') {
                router.replace('/');
                router.replace('/app/admin/group-management');
              }
              payload.$toasted.success('Group has been deleted!');
            })
            .catch(function(error) {
              dispatch('deleteGroup', {});
              payload.$toasted.error('Group could not be deleted!');
            });
        })
        .catch(function(error) {
          dispatch('deleteGroup', {});
          payload.$toasted.error('Group could not be deleted!');
        });
    },
    receiveGroups({ commit }, payload) {
      commit('RECEIVED_GROUPS', payload);
    },
    receivingGroups({ commit }) {
      commit('RECEIVING_GROUPS');
    },
    updateGroup({ commit }, payload) {
      commit('UPDATED_GROUP', payload);
    },
    updatingGroup({ commit }) {
      commit('UPDATING_GROUP');
    },
    deleteGroup({ commit }, payload) {
      commit('DELETED_GROUP', payload);
    },
    deletingGroup({ commit }, payload) {
      commit('DELETING_GROUP', payload);
    }
  }
};
